import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Badge, Form, InputGroup, Button } from 'react-bootstrap';
import { FaSearch, FaFileInvoice } from 'react-icons/fa';
import axios from 'axios';

const GymPayments = () => {
  const [payments, setPayments] = useState([]);
  const [search, setSearch] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [stats, setStats] = useState({ total: 0, count: 0 });

  useEffect(() => {
    fetchPayments();
  }, [search, dateFrom, dateTo]);

  const fetchPayments = async () => {
    try {
      const res = await axios.get('/api/gym/payments', {
        params: { search, dateFrom, dateTo }
      });
      setPayments(res.data);
      
      const total = res.data.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);
      setStats({ total, count: res.data.length });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Container fluid className="py-4">
      <Row className="mb-4">
        <Col><h2>💰 Gym Payments</h2><p className="text-muted">Payment history and records</p></Col>
      </Row>

      <Row className="mb-4">
        <Col md={6}>
          <Card className="text-center" style={{ borderLeft: '4px solid #28a745' }}>
            <Card.Body>
              <h3 className="text-success">Rs. {stats.total.toLocaleString()}</h3>
              <p className="mb-0">Total Revenue</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="text-center" style={{ borderLeft: '4px solid #007bff' }}>
            <Card.Body>
              <h3 className="text-primary">{stats.count}</h3>
              <p className="mb-0">Total Payments</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Row>
            <Col md={4}>
              <InputGroup>
                <InputGroup.Text><FaSearch /></InputGroup.Text>
                <Form.Control placeholder="Search member..." value={search} onChange={(e) => setSearch(e.target.value)} />
              </InputGroup>
            </Col>
            <Col md={3}>
              <Form.Control type="date" placeholder="From Date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
            </Col>
            <Col md={3}>
              <Form.Control type="date" placeholder="To Date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
            </Col>
            <Col md={2}>
              <Button variant="outline-secondary" onClick={() => { setSearch(''); setDateFrom(''); setDateTo(''); }}>Clear</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Body>
          <Table responsive hover>
            <thead>
              <tr>
                <th>Date</th>
                <th>Member</th>
                <th>Phone</th>
                <th>Package</th>
                <th>Amount</th>
                <th>Payment Method</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {payments.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <p className="text-muted">No payments found</p>
                  </td>
                </tr>
              ) : (
                payments.map((payment) => (
                  <tr key={payment.id}>
                    <td>{new Date(payment.paymentDate).toLocaleDateString()}</td>
                    <td><strong>{payment.member?.name}</strong></td>
                    <td>{payment.member?.phone}</td>
                    <td>{payment.package?.name || '-'}</td>
                    <td><strong>Rs. {payment.amount}</strong></td>
                    <td><Badge bg="info">{payment.paymentMethod?.toUpperCase()}</Badge></td>
                    <td><Badge bg="success">PAID</Badge></td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default GymPayments;
